<template>
  <div>
    DERZEIT UNBENUTZT!!!
    <h1>Alle Stunden für {{date.format("DD.MM.yyyy")}}</h1>
    <h2 v-if="user">{{user.name}}</h2>
    <h2 v-else>...</h2>
    <p>Stunden in KW {{date.format("W")}}: {{workingHours.workHoursCurrentWeek | hour}}/{{workingHours.workHoursRequiredCurrentWeek | hour}}</p>
    <hr />
    <a v-on:click="setPreviousDate" class="btn btn-info">Gehe zu {{previousDate.format("DD.MM.yyyy")}}</a> |
    <a v-on:click="setNextDate" class="btn btn-info">Gehe zu {{nextDate.format("DD.MM.yyyy")}}</a>
    <hr />
    <div v-if="hours.length > 0">
      <table class="table">
        <tr>
          <td>Von</td>
          <td>Bis</td>
          <td>Projekt</td>
          <td>Kommentar</td>
        </tr>
        <tr v-for="hour in hours" :key="hour.id">
          <td>{{hour.from | momentHour}}</td>
          <td>{{hour.to | momentHour}}</td>
          <td>{{getProject(hour.projectId).title}}</td>
          <td>{{hour.comment}}</td>
        </tr>
      </table>
      <div>
      </div>
    </div>
    <div v-else>
      Noch keine Stunden für den Termin eingetragen.
    </div>
    <router-link class="btn btn-outline-info" :to="{ path: 'users', query: { }}">Zurück zur Übersicht</router-link>
  </div>
</template>

<style>
  .home {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
</style>

<script>
  import axios from "axios";
  import moment from "moment";
  import Vue from 'vue'


  export default {
    name: "hoursReadonly",
    data() {
      return {
        userId: "",
        user: {},
        hours: [],
        workingHours: {},
        projects: [],
        date: moment(),
        previousDate: moment(),
        nextDate: moment(),
      };
    },
    methods: {
      getProject: function (projectId) {
        if (this.projects && this.projects.length > 0) {
          for (var i = 0; i < this.projects.length; i++) {
            if (this.projects[i].id == projectId) {
              return this.projects[i];
            }
          }
        }
        return { title: "..." };
      },
      setPreviousDate: function () {
        this.setDate(this.previousDate);
      },
      setNextDate: function () {
        this.setDate(this.nextDate);
      },
      setDate: function (date) {
        this.$router.push("/users/hoursReadonly?date=" + date.format("yyyy-MM-DD") + "&userId=" + this.userId);
      },
      loadComponentData: function () {
        //Load user
        axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "user/" + this.userId }).then(result => {
          this.user = result.data;
        }, error => {
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        });
        //Load projects
        axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "projects/" }).then(result => {
          this.projects = result.data;
        }, error => {
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        });

        //Load hours
        axios({ method: "GET", "url": process.env.VUE_APP_API_PATH + "hours/GetByUserAndDate?date=" + this.date.format("yyyy-MM-DD") + "&userId=" + this.userId }).then(result => {
          this.hours = result.data;
        }, error => {
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        });

        axios({ method: "GET", "url": process.env.VUE_APP_API_PATH + "hours/GetRequiredWorkingHours?date=" + this.date.format("yyyy-MM-DD") + "&userId=" + this.userId }).then(result => {
          this.workingHours = result.data;
        }, error => {
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        });
      }
    },
    mounted() {
      //Set date to today
      this.userId = this.$route.query.userId;
      var currentDate = moment();
      if (this.$route.query.date) {
        this.date = moment(this.$route.query.date);
        this.previousDate = moment(this.$route.query.date).subtract(1, 'd');
        this.nextDate = moment(this.$route.query.date).add(1, 'd');
        this.loadComponentData();
      } else {
        this.setDate(currentDate);
      }
    },
    beforeRouteUpdate(to, from, next) {
      next();
      this.date = moment(to.query.date);
      this.previousDate = moment(to.query.date).subtract(1, 'd');
      this.nextDate = moment(to.query.date).add(1, 'd');
      this.loadComponentData();
    },
  };


</script>
